// Add your custom JS here.

jQuery(document).ready(function($){

    // Initialize Lazy Loading.
      $('.lazy').lazy();

    // Basic (Home Page) Slider.
      $('.hp-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        dots: true,
        autoplaySpeed: 5000
      });
    
    // Featured News Slider.
      $('.featured-news').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        dots: true,
        fade: true
      });
    
    // Logo Strip.
      $('.carousel-strip').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        dots: true,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              arrows: false
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });

    // Timeline.
      $('.timeline-strip').slick({
          infinite: false,
          arrows: true,
          dots: false,
          autoplay: false,
          speed: 550,
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      
    // Testimonials Grid.
      $('.testimonial-grid').slick({
        infinite: true,
        arrows: false,
        dots: true,
        autoplay: true,
        speed: 550,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              arrows: true,
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }]
        });
    
    // Hamburger Animations.
      $('[class^="nav-icon"]:not(.offCanvasIcon)').click (function() {
        $(this).toggleClass('open');
      });
    
    // Search Tab event to open Search Drawer.
        $('#topbarSearch').click (function() {
          $(this).toggleClass('open');
          $('.nav-search').toggleClass('open');
        });
    
    // Get current year for colophon.
        const d = new Date();
        let year = d.getFullYear();
        document.getElementById('copyrightYear').innerHTML = year;
    
    // Conditional classes to change elements on scroll.
        function scrollClass() {
          var scroll = $(window).scrollTop();
          if (scroll >= 100) {
            //$( '.home .top-bar,.home #main-nav.bg-primary,.home .nav-search' ).addClass( 'xparent' );
            $( '.backToTop' ).addClass( 'onScreen' );
            $( '.fixed-header .img-fluid' ).addClass( 'scrolling' );
          } else {
            //$( '.home .top-bar,.home #main-nav.bg-primary,.home .nav-search' ).removeClass( 'xparent' );
            $( '.backToTop' ).removeClass( 'onScreen' );
            $( '.fixed-header .img-fluid' ).removeClass( 'scrolling' );
          }
        }

      // Fire on load...
        scrollClass();

      // ...and on scroll.
        $(window).scroll(function() {
          scrollClass();
        });

    // Offset anchor links by header height when header is fixed.
        var header = document.querySelector('.fixed-header');
        var headerHeight = header.offsetHeight;
        document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
          anchor.addEventListener('click',
            function (event) {
              event.preventDefault();
              var target = document.querySelector(
                this.getAttribute('href')
              );
              var targetPosition = target
              .getBoundingClientRect().top - headerHeight;
              window.scrollTo({
                top: targetPosition + window.pageYOffset,
                behavior: 'smooth'
              });
            });
          }); 

    // Set Up Tabs & Accs
        $( 'section.tabs-accordions .nav-tabs .nav-link, section.tabs-accordions .nav-pills .nav-link').first().addClass('active');
        $( 'section.tabs-accordions .tab-content .tab-pane').first().addClass('active show');
        $( 'section.tabs-accordions .accordion .accordion-collapse' ).first().addClass('show');
        $( 'section.tabs-accordions .accordion .accordion-button:not(:first)' ).addClass('collapsed');
    
    // Classes for scroll fx.
        jQuery('.pulseMeIn').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__pulse',
            offset: 100
          });
    
        jQuery('.rubberbandMeIn').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__rubberBand',
            offset: 100
          });
    
        jQuery('.backMeInLeft').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__backInLeft',
            offset: 100
          });
    
        jQuery('.backMeInRight').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__backInRight',
            offset: 100
          });
    
        jQuery('.backMeInUp').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__backInUp',
            offset: 100
          });
    
        jQuery('.backMeInDown').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__backInDown',
            offset: 100
          });
    
        jQuery('.bounceMeIn').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__bounceIn',
            offset: 100
          });
    
        jQuery('.bounceMeInDown').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__bounceInDown',
            offset: 100
          });
    
        jQuery('.bounceMeInLeft').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__bounceInLeft',
            offset: 100
          });
    
        jQuery('.bounceMeInRight').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__bounceInRight',
            offset: 100
          });
    
        jQuery('.bounceMeInUp').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__bounceInUp',
            offset: 100
          });
    
        jQuery('.fadeMeIn').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__fadeIn',
            offset: 100
          });
    
        jQuery('.fadeMeInDown').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__fadeInDown',
            offset: 100
          });
    
        jQuery('.fadeMeInDownBig').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__fadeInDownBig',
            offset: 100
          });
    
        jQuery('.fadeMeLeft').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__fadeInLeft',
            offset: 100
          });
    
        jQuery('.fadeMeLeftBig').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__fadeInLeftBig',
            offset: 100
          });
    
        jQuery('.fadeMeRight').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__fadeInRight',
            offset: 100
          });
    
        jQuery('.fadeMeRightBig').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__fadeInRightBig',
            offset: 100
          });
    
        jQuery('.fadeMeUp').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__fadeInUp',
            offset: 100
          });
    
        jQuery('.fadeMeUpBig').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__fadeInUpBig',
            offset: 100
          });
    
        jQuery('.flipMeInX').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__flipInX',
            offset: 100
          });
    
        jQuery('.flipMeInY').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__flipInY',
            offset: 100
          });
    
        jQuery('.lightSpeedMeInRight').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__lightSpeedInRight',
            offset: 100
          });
    
        jQuery('.lightSpeedMeInLeft').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__lightSpeedInLeft',
            offset: 100
          });
    
        jQuery('.jackInTheBoxMeIn').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__jackInTheBox',
            offset: 100
          });
    
        jQuery('.zoomMeIn').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__zoomIn',
            offset: 100
          });
    
        jQuery('.zoomMeInDown').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__zoomInDown',
            offset: 100
          });
    
        jQuery('.zoomMeInLeft').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__zoomInLeft',
            offset: 100
          });
    
        jQuery('.zoomMeInRight').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__zoomInRight',
            offset: 100
          });
    
        jQuery('.zoomMeInUp').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__zoomInUp',
            offset: 100
          });
    
        jQuery('.slideMeInDown').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__slideInDown',
            offset: 100
          });
    
        jQuery('.slideMeInLeft').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__slideInLeft',
            offset: 100
          });
    
        jQuery('.slideMeInRight').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__slideInRight',
            offset: 100
          });
    
        jQuery('.slideMeInUp').addClass('hidden').viewportChecker({
            classToAdd: 'visible animate__animated animate__slideInUp',
            offset: 100
          });
});